import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useCallback} from "react";
import PlayfulHeader from "../components/common/PlayfulHeader";
import {useIsMobile} from "../hooks/useIsMobile";
import {useHomepageStats} from "../hooks/queries/useStats";

const EMPTY_STATS = { matches: 0, tournaments: 0, points: 0, achievements: 0, players: 0 };

function Homepage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const handleOnClick = useCallback((path: string) => navigate(path), [navigate]);
  const { data: stats = EMPTY_STATS } = useHomepageStats();
  const isMobile = useIsMobile();

  const playfulHeaderKey = isMobile ? "welcomeHeaderRawMobile" : "welcomeHeaderRaw";

    return (
        <div className="base-container homepage-container m-3 text-center">
          <PlayfulHeader text={t(playfulHeaderKey)} />
          <p><div className="mt-4" dangerouslySetInnerHTML={{__html: t("welcomeText1", {interpolation: {escapeValue: false}})}}/></p>
          <div className="stat-orbit-container" id="stat-orbit">
            <div className="centerpiece">
              <div className="achievement-image-div">
                <img src="/icons/table-tennis.png" style={{ height: "128px", width: "128px" }} />
              </div>
            </div>
            <div className="stat stat-1">
              <span className="number">{stats.tournaments}</span>
              <span className="label">{t("homepageTournaments")}</span>
            </div>
            <div className="stat stat-2">
              <span className="number">{stats.matches.toLocaleString()}</span>
              <span className="label">{t("homepageMatches")}</span>
            </div>
            <div className="stat stat-3">
              <span className="number">{stats.achievements}</span>
              <span className="label">{t("homepageAchievements")}</span>
            </div>
            <div className="stat stat-4">
              <span className="number">{stats.players}</span>
              <span className="label">{t("homepagePlayers")}</span>
            </div>
            <div className="stat stat-5">
              <span className="number">{stats.points.toLocaleString()}</span>
              <span className="label">{t("homepagePoints")}</span>
            </div>
          </div>
          { /* This would be a hassle to write in translate files */ }
          {i18n && i18n.language === "cs" ?
            <div className="fun-stats-sentence">
              Celkem <span className="highlight">{stats.players}</span> hráčů se zúčastnilo alespoň jednoho z <span className="highlight">{stats.tournaments}</span> turnajů,
              ve kterých se během <span className="highlight">{stats.matches.toLocaleString()}</span> zápasů odehrálo <span className="highlight">{stats.points.toLocaleString()}</span> výměn,
              za které bylo uděleno <span className="highlight">{stats.achievements}</span> ocenění.
            </div> : <div className="fun-stats-sentence">
              A total of <span className="highlight">{stats.players}</span> players participated in at least one of <span className="highlight">{stats.tournaments}</span> tournaments,
              where <span className="highlight">{stats.points.toLocaleString()}</span> rallies were played across <span className="highlight">{stats.matches.toLocaleString()}</span> matches,
              and <span className="highlight">{stats.achievements}</span> achievements were awarded.
            </div>
          }

          <div className="link-container pb-4 mb-5">
            <a onClick={() => handleOnClick("/tournaments")} className="home-link" style={{ color: 'var(--accent)' }}>{t("tournaments")}</a>
            <a onClick={() => handleOnClick("/players")} className="home-link" style={{ color: 'var(--accent)' }}>{t("ladders")}</a>
          </div>
          <div className="footer" dangerouslySetInnerHTML={{__html: t("welcomeText2", {interpolation: {escapeValue: false}})}} />
        </div>
    );
}

export default Homepage
